import axios from 'axios';
import React from 'react';
import d3 from 'd3';
import * as topojson from 'topojson-client';
import _ from 'lodash';
let portdata = {
    "shanghai": {
        rank: 1,
        lines: [[120.358,31.222],[135.796,24.734]],
    },
    "singapore": {
        rank: 2,
        lines: [[103.288,1.316],[109.258,5.376]],
    },
    "shenzhen": {
        rank: 3,
        lines: [[113.495,22.555],[121.349,20.220],[132,18]]
    },
    "ningbo": {
        //rank: 6,
        rank: 4,
        lines:[[121.839,29.941],[125.839,25.941]]
    },
    "hongkong": {
        //rank: 4,
        rank: 5,
        lines: [[114.130,22.251],[124.349,18.220],[130,10]]    
    },
    "busan": {
        //rank: 5,
        rank: 6,
        lines: [[128.792,35.165],[132.792,38.165]]
    },
    "qingdao": {
        rank: 7,
        lines: [[120.372,36.056],[122.872,31.056],[132.372,29.856]]
    },
    "zhebelali": {
        //rank: 9,
        rank: 8,
        lines: [[55.048,25.021],[61.048,23.221]]
    },
    "guangzhou": {
        //rank: 8,
        rank: 9,
        lines: [[113.428,23.082],[113.428,17.082]]
    },
    "tianjin": {
        rank: 10,
        lines: [[116.522,38.488],[122.885,38.475],[123.522,36.488]]
    }
};


/*"shanghai":[[120.358,31.222]],
"singapore":[[103.288,1.316]],
"shenzhen":[[113.495,22.555]],
"hongkong":[[114.130,22.251]],
"busan":[[128.792,35.165]],
"ningbo":[[121.839,29.941]],
"qingdao"[[120.372,36.056]],
"guangzhou":[[113.428,23.082]],
"zhebelali":[[55.048,25.021]],
"tianjin":[[116.522,38.488]]*/


const π = Math.PI;
function miller(λ, φ) {
  return [
    λ,
    1.25 * Math.log(Math.tan(π / 4 + .4 * φ))
  ];
}

miller.invert = function(x, y) {
  return [
    x,
    2.5 * Math.atan(Math.exp(.8 * y)) - .625 * π
  ];
};

(d3.geo.miller = function() { return d3.geo.projection(miller); }).raw = miller;


const getCircleCenter = function(finalpoints,projection,d) {
    let x1 = projection(finalpoints[0])[0];
    let y1 = projection(finalpoints[0])[1];
    let x2 = projection(finalpoints[1])[0];
    let y2 = projection(finalpoints[1])[1];
    let D = Math.sqrt(Math.pow(x2-x1,2)+Math.pow(y2-y1,2));
    
    let x3 = x2 + (x2-x1) * d / D;
    let y3 = y2 + (y2-y1) * d / D;
    return [x3,y3];
}


let mapdata = null;

export default class PortMap extends React.Component {
    constructor() {
        super(...arguments);
        this._drawWorld = _.debounce(this.drawWorld,300)
    }
    componentDidMount() {
        Promise.all(
            [axios.get("data/asia.json")]).then((responsearray) => {
           mapdata = responsearray[0].data;
           
           this.drawWorld();
        });
    }
    componentDidUpdate(oldprops,oldstate,oldcontext) {
        if(oldcontext.containerWidth && oldcontext.containerWidth != this.context.containerWidth) {
            this._drawWorld();
        }
    }
    getHeight(width) {
        return Math.ceil(width*1/1.45);        
    }
    drawWorld() {
        if(mapdata == null) { return; }
        
        const svgwidth = this.props.width || this.context.containerWidth || 100;
        const svgheight = this.getHeight(svgwidth);
        const projection = d3.geo.equirectangular().precision(0.1).scale(svgwidth*490/994.7);
        projection.translate([
            svgwidth / 2 - (projection([108.15,24.55])[0]-projection([0,0])[0]), 
            svgheight / 2 - (projection([108.15,24.55])[1]-projection([0,0])[1])]);
        projection.clipExtent([projection([51.8,63.4]),projection([164.5,-14.3])]);
        const path = d3.geo.path().projection(projection);
        const svg = d3.select(this.refs.map);
        svg.selectAll("*").remove();
        
        svg.append("path")
            .datum(topojson.feature(mapdata,mapdata.objects.land))
            .attr("d", path)
            .attr("class","land")
            .style("fill","#fff")
            .style("stroke","#aaa")
            .style("stroke-width","1px");

        
           
        svg.append("path")
            .datum(topojson.feature(mapdata,mapdata.objects.borders))
            .attr("d", path)
            .style("fill","none")
            .attr("class","borders")
            .style("stroke","#aaa")
            .style("stroke-width","1px");
        
        
        svg.append("path")
            .datum(topojson.feature(mapdata,mapdata.objects.disputed))
            .attr("d", path)
            .attr("class","disputed")
            .style("fill","none")
            .style("stroke","#aaa")
            .style("stroke-width","1px")
            .style("stroke-dasharray","3,1");
            
        let lineFunction = d3.svg.line()
            .x(function(d) { return projection(d)[0]; })
            .y(function(d) { return projection(d)[1]; })
            .interpolate("linear");    
        for(let port in portdata) {
            let portobj = portdata[port];
            const radius = 8;
            const circlepadding = 1;
            const circleoffset = 2;
            
            svg.append("path")
               .attr("class","ranklines")
               .attr("d",lineFunction(portobj.lines))
               .style("stroke","#000")
               .style("stroke-width","1px")
               .style("fill","none");
           let centerpoint = getCircleCenter(portobj.lines.slice(portobj.lines.length-2),projection,radius+circleoffset) 
           svg.append("circle")
               .attr("cx",centerpoint[0])
               .attr("cy",centerpoint[1])
               .attr("r",radius)
               .style("fill","#000")
               .style("stroke","none");
           
           svg.append("text")
               .text(""+portobj.rank)
               .style("stroke","none")
               .style("fill","#fff")
               .style("font-size", (2 * radius - 2* circlepadding) + "px")
               .style("dominant-baseline","middle")
               .style("text-anchor","middle") 
               .style("font-weight","500")
               .attr("x",centerpoint[0])
               .attr("y",centerpoint[1] + circlepadding)
               
               
          
        }
        var graticule = d3.geo.graticule();

        svg.append("path")
            .datum(graticule)
            .attr("class", "graticule")
            .attr("d", path);  
    }
    render() {
        const svgwidth = this.props.width || this.context.containerWidth || 100;
        return <div>
            <svg ref="map" width={svgwidth} height={this.getHeight(svgwidth)} />
        </div>
        
    }
}

PortMap.contextTypes = {
    containerWidth: React.PropTypes.number
};


// WEBPACK FOOTER //
// ./src/js/components/special/PortMap/PortMap.jsx